import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { StyledAnchor } from "./_.styled";

const NavButton = ({
  label,
  href,
  floatLeft = false,
  glyph = "navigate_next",
  ...props
}) => (
  <StyledAnchor
    href={href}
    linkComponent={Link}
    glyph={glyph}
    floatLeft={floatLeft}
    glyphColor="secondary"
    fontWeight="bold"
    {...props}
  >
    {label}
  </StyledAnchor>
);

NavButton.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  glyph: PropTypes.string,
};

export default NavButton;
